import { render, staticRenderFns } from "./ChangeGroupModal.vue?vue&type=template&id=6fbfde76&"
import script from "./ChangeGroupModal.vue?vue&type=script&lang=js&"
export * from "./ChangeGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports